import { render, staticRenderFns } from "./billedList.vue?vue&type=template&id=364204a5"
import script from "./billedList.vue?vue&type=script&lang=js"
export * from "./billedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports